import React from 'react';
import { Section } from '../Section';
import { TransformCTA } from '../TransformCTA';
const scenarios = ['An elevated creatinine', 'A declining eGFR', 'Albuminuria', 'An abnormal potassium', 'Diabetes', 'Hypertension', 'Heart failure', 'Multiple medications'];
export function About() {
  return <Section tone="white" eyebrow="Dr. Karito" title="Why I created Renal Decision Desk™" data-id="element-80" data-mp="yqd2y1b1r2mc">
      <div className="grid gap-7 lg:grid-cols-[minmax(0,320px)_minmax(0,1fr)] lg:items-start lg:gap-10" data-id="element-81" data-mp="ayxstmd13h0j">
        <figure className="mx-auto w-full max-w-[320px]" data-id="element-82" data-mp="61panlrvrcza">
          <img src="https://cdn.magicpatterns.com/uploads/12u7a6vTMMwF3JX6kLxTCn/Dra_Karito_real.png" alt="Dr. Karito, physician and creator of Renal Decision Desk™" className="w-full rounded-3xl border border-ink-line object-cover" width={942} height={1673} data-id="element-83" data-mp="js15vtjrhrun" />
          <figcaption className="mt-3 text-center" data-id="element-84" data-mp="3jgc49rxl6dfz">
            <p className="font-display text-xl font-bold text-ink" data-id="element-85" data-mp="3jdpzu15zse1z">Dr. Karito</p>
            <p className="text-[13px] font-semibold text-ink-soft" data-id="element-86" data-mp="338yoafixtjun">
              Physician & Creator of Renal Decision Desk™
            </p>
          </figcaption>
        </figure>

        <div className="space-y-4 text-[15px] leading-relaxed text-ink-soft sm:text-[16.5px]" data-id="element-87" data-mp="3d0cs2zhx95tl">
          <p data-id="element-88" data-mp="3hwthdx0uxq89">
            For years, I saw the same problem repeatedly. Physicians weren’t
            necessarily lacking information. The information was already there.
            The guidelines existed. The references existed. The clinical
            knowledge existed.
          </p>
          <p className="rounded-2xl border-l-4 border-cyan-brand bg-cyan-light px-5 py-4 font-display text-[17px] font-semibold italic leading-snug text-ink sm:text-xl" data-id="element-89" data-mp="2u7in8ye0iu33">
            But there was a gap between “I know this information exists” and
            “What do I need to consider for THIS patient right now?”
          </p>
          <p data-id="element-90" data-mp="efl29kxil4h8">When you’re sitting across from a patient with:</p>
          <ul className="grid grid-cols-2 gap-2" data-id="element-91" data-mp="2ajrcjr7vtbjj">
            {scenarios.map(scenario => <li key={scenario} className="rounded-xl bg-cream px-3 py-2.5 text-[13px] font-semibold text-ink ring-1 ring-ink-line" data-id="element-92" data-mp="25m92tym1isah">
                {scenario}
              </li>)}
          </ul>
          <p data-id="element-93" data-mp="2fhsycjwozoyp">
            the challenge isn’t always finding another piece of information. The
            challenge is organizing the information into a structured decision
            process.
          </p>
          <p data-id="element-94" data-mp="20mcy1x5iqwtv">
            That’s why I created Renal Decision Desk™. Not as another textbook.
            Not as another massive collection of guidelines. And not as
            something you’re expected to read from beginning to end.
          </p>
          <p data-id="element-95" data-mp="184r5y17huoys">
            I designed it as a visual clinical decision-navigation system. A
            place to start. A route to follow. A structure for the questions
            that need to be considered.
          </p>
          <p className="font-semibold text-ink" data-id="element-96" data-mp="tz8rmt7x8zu2">
            So when the next renal scenario appears in your consultation, you
            don’t have to begin with “Where do I search?” You can begin with
            “Which route am I on?”
          </p>
          <p className="font-display text-lg font-semibold italic text-ink" data-id="element-97" data-mp="p0xd456om15i">
            — Dr. Karito
          </p>
        </div>
      </div>

      <TransformCTA label="I want the clinical route" sub="6 clinical decision volumes • 5 premium bonuses • Lifetime access" data-id="element-98" data-mp="1crt3qyzeiqb6" />
    </Section>;
}